import { computed, ComputedRef } from 'vue'

import { IncidentId } from '@collector/sportsapi-client-legacy'

import { getPitchIncidentIds } from '../configuration'
import { injectPitchIncidentsConfig } from '../provide-inject'
import { useBlockades } from './useBlockades'

export function usePitchIncidentsBlockades(): {
  isPitchIncidentBlocked(incidentId: IncidentId): boolean
  isEveryPitchIncidentBlocked: ComputedRef<boolean>
} {
  const { isIncidentBlocked } = useBlockades()
  const pitchIncidentsConfig = injectPitchIncidentsConfig()

  const pitchIncidentIds = getPitchIncidentIds(
    pitchIncidentsConfig.pitchIncidents.incidentButtonData,
  )

  function isPitchIncidentBlocked(incidentId: IncidentId): boolean {
    return isIncidentBlocked(
      incidentId,
      pitchIncidentsConfig.blockedPitchIncidentsMap,
    )
  }

  const isEveryPitchIncidentBlocked = computed(() =>
    [...pitchIncidentIds].every(isPitchIncidentBlocked),
  )

  return {
    isPitchIncidentBlocked,
    isEveryPitchIncidentBlocked,
  }
}
